import gql from 'graphql-tag';

export const makeBuildReport = gql`mutation($materials: [ID]!, $householdMembers: Int!, $surfaceArea: Int!, $budget: Int!, $region: ID!){
    makeBuildReport(input: {
        buildingMaterialIds: $materials,
        numberOfHouseHoldMembers: $householdMembers,
        buildSquareFootage: $surfaceArea,
        budget: $budget,
        region: $region
    }) {
        id
    }
}`;

export const getBuildReport = gql`query($id: Int!) {
    getBuildReport(id: $id) {
        BuilderName,
        TotalScore,
        ScoreMessage {
            ... on object_ScoreMessage {
                message
            }
        }
        LeftoverBudget {
            value,
            unit {
                abbreviation
            }
        }
        SScore,
        SWhatWasGood {
            ... on object_AnalizedMessage {
                id,
                message,
                messageType,
                analyzeType
            }
        },
        SWhatCouldImprove {
            ... on object_AnalizedMessage {
                id,
                message,
                messageType,
                analyzeType
            }
        },
        EEScore,
        EEWhatWasGood {
            ... on object_AnalizedMessage {
                id,
                message,
                messageType,
                analyzeType
            }
        },
        EEWhatCouldImprove {
            ... on object_AnalizedMessage {
                id,
                message,
                messageType,
                analyzeType
            }
        },
        BWhatWasGood {
            ... on object_AnalizedMessage {
                id,
                message,
                messageType,
                analyzeType
            }
        },
        BWhatCouldImprove {
            ... on object_AnalizedMessage {
                id,
                message,
                messageType,
                analyzeType
            }
        },
        ElectricityExpenses {
            ... on object_Expenses {
                buildExpense,
                regionAverageExpense,
                costDifference,
                timePeriod,
                savingsMessage {
                    ... on object_SavingsMessage {
                        message,
                        icon
                    }
                },
                monthlyResourceExpense {
                    ... on object_MonthlyResourceExpense {
                        resourceType
                    }
                }
            }
        },
        WaterExpenses {
            ... on object_Expenses {
                buildExpense,
                regionAverageExpense,
                costDifference,
                timePeriod,
                savingsMessage {
                    ... on object_SavingsMessage {
                        message,
                        icon
                    }
                },
                monthlyResourceExpense {
                    ... on object_MonthlyResourceExpense {
                        resourceType
                    }
                }
            }
        },
        GasExpenses {
            ... on object_Expenses {
                buildExpense,
                regionAverageExpense,
                costDifference,
                timePeriod,
                savingsMessage {
                    ... on object_SavingsMessage {
                        message,
                        icon
                    }
                },
                monthlyResourceExpense {
                    ... on object_MonthlyResourceExpense {
                        resourceType
                    }
                }
            }
        }
    }
}`;
